// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"146":"b625470f","254":"aa16fc70","298":"ab2fd803","431":"3d68becc","485":"3d257027","504":"60bb9d20"}[chunkId] + ".chunk.css";
};